import { Card, Flex, Heading } from '@weareberyl/design-system'
import { Col, Row } from 'antd'

import FeatureFlags from '~/components/FeatureFlags'
import HeadTitle from '~/components/HeadTitle'
import ServiceNowAuth from '~/components/ServiceNowAuth'
import { useCurrentUser } from '~/hooks'
import UserSummary from '../User/Summary'
import Token from './Token'

const Me = () => {
  const [user] = useCurrentUser()

  if (!user?.id) return null

  return (
    <Card>
      <UserSummary id={user.id} />
    </Card>
  )
}

const AccountPage = () => (
  <>
    <HeadTitle pageTitle="Account settings" />
    <Card mb={4} p={5} pb={3} flex={1}>
      <Heading mb={5} variant="callout">
        ⚙️ Settings
      </Heading>
    </Card>
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={16}>
        <Flex style={{ gap: 16 }}>
          <Me />
          <Card p={5}>
            <Token />
          </Card>
        </Flex>
      </Col>
      <Col xs={24} lg={8}>
        <Flex style={{ gap: 16 }}>
          <Card p={5}>
            <FeatureFlags />
          </Card>
          <Card p={5}>
            <ServiceNowAuth />
          </Card>
        </Flex>
      </Col>
    </Row>
  </>
)

export default AccountPage
